import React from 'react';
import { Helmet } from 'react-helmet';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '~/training/state';
import { formatDocumentTitle } from './formatDocumentTitle';

const selector = (s: TrainingState) =>
  select(s, 'title', 'items', 'activeItemPosition');

/** Sets `<title>` from course + current sequence (CAT-1212 / EL–E2). */
export const DocumentTitle = () => {
  const { title, items, activeItemPosition } = useTrainingStore(selector);

  // Match createNavigationSlice.next: when positions duplicate, take the last match.
  let sequence: (typeof items)[number] | undefined;
  for (let i = items.length - 1; i >= 0; i--) {
    const item = items[i];
    if (item.kind === 'sequence' && item.position === activeItemPosition) {
      sequence = item;
      break;
    }
  }

  const documentTitle = formatDocumentTitle(
    title,
    sequence?.kind === 'sequence' ? sequence.title : undefined
  );

  return (
    <Helmet>
      <title>{documentTitle}</title>
    </Helmet>
  );
};
